import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";
import { getProducts, getProductsByStore, merge } from "../helpers/Products";


export default function ProductsByStore() {
    const { appState } = useAppState();
    const [stores, setStores] = useState<Array<any>>([])
    const [search, setSearch] = useState<string | null>(null)
    const [secondaryId, setSecondaryId] = useState<string | null>(null)
    const [mainId, setMainId] = useState<string | null>(null)
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });
    const abortController = useRef<AbortController>();

    const mainIdRef = useRef<HTMLInputElement>(null)
    const secondaryIdRef = useRef<HTMLInputElement>(null)

    const [merging, setMerging] = useState<boolean>(false)

    const updateMainId = (id) => {
        if (mainIdRef.current) {
            mainIdRef.current.value = id;
        }

        setMainId(id)
    }

    const updateSecondaryId = (id) => {
        if (secondaryIdRef.current) {
            secondaryIdRef.current.value = id;
        }

        setSecondaryId(id)
    }


    const handleMerge = () => {
        if (secondaryId === null || mainId === null) {
            return;
        }

        setMerging(true);
        merge(parseInt(secondaryId), parseInt(mainId), { signal: abortController.current.signal }).then(() => {
            updateSecondaryId(null)
            updateMainId(null)

            setMerging(false)
        }).catch(() => {
            setMerging(false)
        })
    }


    useEffect(() => {
        if (merging === false) {
            if (abortController.current) {
                abortController.current.abort()
            }

            abortController.current = new AbortController();
            getProductsByStore(10, page, search, { signal: abortController.current.signal }).then((result) => {
                setStores(result.data)
                setMeta({
                    page: result.current_page,
                    totalPages: result.last_page,
                })
            })
        }
    }, [page, search, merging])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-xl">Products</h1>
                    <input onChange={(event) => { setSearch(event.target.value) }}></input>
                </div>
                <Link to="/products/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create Product</Link>
            </div>
            <div className="flex justify-between items-center">
                <div>
                    <input ref={mainIdRef} placeholder="Main Id" className="border border-blue-500" onChange={(event) => { setMainId(event.target.value) }}></input>
                    <input ref={secondaryIdRef} placeholder="Secondary Id" className="border border-blue-500" onChange={(event) => { setSecondaryId(event.target.value) }}></input>
                </div>
                {merging ? null : <button onClick={handleMerge} className="px-4 py-2 bg-blue-500 text-white rounded">Merge</button>}

            </div>
            <div className={`grid gap-x-4 grid-cols-${Object.keys(stores).length}`}>
                {Object.keys(stores).map((storeId) => {
                    return (<div className="mt-3 p-3 rounded bg-white">
                        <h3>{storeId}</h3>
                        {stores[storeId].map((product: any) => {
                            return (
                                <div className="border-b h-[170px]">
                                    <div className="flex gap-x-2">
                                        <button className="px-6 py-1 text-lg rounded bg-blue-500 hover:bg-blue-600 text-white" onClick={() => { updateMainId(product.id) }}>Main ID</button>
                                        <button className="px-6 py-1 text-lg rounded bg-blue-500 hover:bg-blue-600 text-white" onClick={() => { updateSecondaryId(product.id) }}>Secondary ID</button>
                                    </div>
                                    <div>
                                        {product.id} | {product.name}
                                    </div>
                                    <div>
                                        {product.sku}
                                    </div>
                                    <div>
                                        {product.brand?.name}
                                    </div>
                                </div>
                            )
                        })}
                    </div>)
                })}
            </div>
            {/* {
                products && products.length > 0 ? (
                    <div className="w-full mt-5">
                        <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                    </div>
                ) : null
            } */}

        </>
    );
}
